import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  wraper: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: neutrals.neutralGrays.titanium,
    backgroundColor: neutrals.white,
  },
  header: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: {
    width: 20,
    height: 20,
    padding: 2,
  },
  text: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
  options: {
    borderTopWidth: 1,
    borderColor: neutrals.neutralGrays.titanium,
  },
  optionsOnlyIcon: {
    height: 220,
    paddingTop: 16,
    borderWidth: 1,
    borderColor: neutrals.neutralGrays.titanium,
    backgroundColor: neutrals.white,
    borderRadius: 8,
  },
  option: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  optionOnlyIcon: {
    paddingHorizontal: 24,
    paddingTop: 8,
    paddingBottom: 16,
  },
});
